import dayjs from 'dayjs';

/**
 * Whether the member can cancel this reservation (mirrors backend policy).
 */
export function canMemberCancelReservation(reservation, now = dayjs()) {
  const status = reservation.status;
  if (status === 'cancelled' || status === 'completed' || status === 'rejected') {
    return false;
  }
  if (status === 'pending') {
    return true;
  }

  const cancellationHours = reservation.reservable?.cancellationHours ?? 24;
  const [hours, minutes] = reservation.startTime.split(':').map(Number);
  const eventStart = dayjs(reservation.date)
    .hour(hours)
    .minute(minutes)
    .second(0)
    .millisecond(0);

  return now.isBefore(eventStart.subtract(cancellationHours, 'hour'));
}
